module.exports = __webpack_public_path__ + "img/logo.4553627.png";